export default theme => ({
  root: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider,
    marginBottom: theme.spacing(2),
    '& .MuiTab-root': {
      minWidth: 80,
      textTransform: 'none',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    '& .MuiTab-root .MuiSvgIcon-root': {
      verticalAlign: 'middle',
      width: 18,
      height: 18,
      marginRight: theme.spacing(1),
      marginTop: -4
    },
    '& .MuiTab-root.error': {
      color: theme.palette.error.main
    },
    '&.MuiTabs-root.error .MuiTabs-indicator': {
      backgroundColor: theme.palette.error.main
    }
  }
});
